<script lang="ts" setup>
import { ref, inject  } from 'vue';
import { fetch } from '@/summit/2023/plugins/fetch';
import Pagination from '@/summit/2023/components/Pagination.vue';
import { JOURNALISM_CATEGORY_ID } from '@/summit/2023/constants';

defineOptions({
  name: 'PageHomeJournalism',
});

const { resizeComponent } = inject<any>('floatNavigator');
const newsList = ref<any>(null);
const limit = 6;
const pager = ref({});

const getNewsList = async (offset: number = 0) => {
  const { isSuccess, data } = await fetch('/api/news/v1/page', {
    data: {
      cid: JOURNALISM_CATEGORY_ID,
      beginTime: '2023-01-01 00:00:00',
      offset,
      limit,
    },
  });


  if (isSuccess) {
    newsList.value = data.newsList;

    pager.value = {
      offset,
      total: data.totalCount,
    }

    resizeComponent();
  }
}

const onChange = (offset: number) => {
  getNewsList(offset);
}

getNewsList();
</script>

<template>
  <section class="page-home-journalism" v-if="newsList">
    <h2 class="mt-[128px]">最新资讯</h2>
    <p>INFORMATION</p>
    <div class="flex-start mt-[31px] flex flex-wrap">
      <div class="card mb-[24px]" :class="[(index + 1) % 3 ? 'mr-[24px]' : '']" v-for="(item, index) in newsList" :key="item.id">
        <RouterLink :to="`/journalism/detail/${item.id}`" class="block no-underline">
          <div class="h-[200px] w-[384px] overflow-hidden rounded-t-4px">
            <img :data-src="item.cover" class="lazyload card-img object-cover">
          </div>
          <div class="card-description">
            <h4 class="line-clamp-2 mx-[16px] pt-[8px]">{{ item.title }}</h4>
            <p class="journalism-time mx-[16px] mt-8px">{{ item.releaseTime }}</p>
          </div>
        </RouterLink>
      </div>
    </div>

    <Pagination class="mt-8px" :pager="pager" :limit="limit" @change="onChange" />
  </section>
</template>

<style lang="scss" scoped>
.page-home-journalism {
  width: 1200px;
  margin: 0 auto;

  h2 {
    // height: 47px;
    color: rgb(0, 71, 157);
    font-weight: 500;
    font-size: 32px;
    line-height: 47px;
    letter-spacing: 0;
    // text-align: center;
  }

  P {
    color: rgba(0, 71, 157, 1);
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0;
    // text-align: center;
    // vertical-align: top;
  }

  .card {
    width: 384px;
    height: 310px;

    &:hover {
      width: 384px;
      height: 310px;
      box-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
      cursor: pointer;

      h4 {
        width: 352px;
        height: 66px;
        color: rgb(0, 71, 157);
        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        letter-spacing: 0;
      }

      .card-img {
        width: 100%;
        height: 200px;
        overflow: hidden;
        border-radius: 4px 4px 0 0;
        transform: scale(1.2);
      }
    }
  }

  .card-img {
    width: 100%;
    height: 200px;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    transition: all 0.5s;
  }

  .card-description {
    width: 384px;
    height: 110px;
    background: rgb(255, 255, 255);
    // border-radius: 4px 4px 0 0;
  }

  h4 {
    display: -webkit-box;
    width: 352px;
    height: 66px;
    overflow: hidden;
    color: rgb(45, 45, 45);
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .journalism-time {
    width: 352px;
    height: 18px;
    overflow: hidden;
    color: rgb(89, 87, 87);
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0;
    text-overflow: ellipsis;
  }
}
</style>
